import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ko_KR from './ko/ko.json';
import en from './en/en.json';
import { ko, enUS } from 'date-fns/esm/locale';
import { registerLocale } from 'react-datepicker';

export const languages = [
  { code: 'ko', locale: 'KR', name: '한국어' },
  { code: 'en', locale: 'US', name: 'English' },
];

const resources = {
  'ko-KR': {
    translation: ko_KR,
  },
  'en-US': {
    translation: en,
  },
};

const getDomain = () => {
  const hostname = window.location.hostname;
  const domainParts = hostname.split('.');
  const domainLength = domainParts.length;

  if (domainLength < 2) {
    return hostname;
  }

  const rootDomain = domainParts.slice(domainLength - 2).join('.');
  return rootDomain;
};

const detectorOptions = {
  order: ['cookie'],
  caches: ['cookie'],
  lookupCookie: 'lang',
  cookieOptions: {
    domain: getDomain(),
    secure: true,
    sameSite: false,
  },
  convertDetectedLanguage: (lng: string) =>
    lng.includes('en') ? 'en-US' : 'ko-KR',
};

registerLocale('ko-KR', ko);
registerLocale('en-US', enUS);

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...(import.meta.env.VITE_SHOW_LANGUAGE_SELECTOR === 'false' && {
      lng: 'ko-KR',
    }),
    resources,
    fallbackLng: 'ko-KR',
    debug: process.env.NODE_ENV !== 'prod',
    interpolation: {
      escapeValue: false,
    },
    detection: detectorOptions,
  });

export default i18n;
